import DescriptionIcon from '@material-ui/icons/Description';
import { Action, Localization, MaterialTableProps } from 'material-table';
import React from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import TableWithEdit from '../../../../components/Tables/TableWithEdit';
import { tFormKey, tKey } from '../../../../helpers/translate';
import { downloadInvoiceDocument } from '../../../../redux/accounting/actions';
import { InvoiceListItem } from '../../../../redux/accounting/definitions';
import style from './invoicesList.module.scss';

interface InvoicesListProps {
  tableData: MaterialTableProps<InvoiceListItem>;
  downloadAction?: boolean;
  checkedRows?: number;
  downloadInvoice: (file_id: number, filename: string) => void;
  onSelectionChange?: (invoices: InvoiceListItem | InvoiceListItem[]) => void;
}

const InvoicesList: React.FC<InvoicesListProps> = ({
  tableData,
  downloadAction,
  checkedRows,
  downloadInvoice,
  onSelectionChange,
}) => {
  const history = useHistory();

  const actionIcons = {
    Document: () => <DescriptionIcon style={{ color: 'rgba(0, 0, 0, 0.54)' }} />,
  };

  const tableActions = ():
    | (Action<InvoiceListItem> | ((rowData: InvoiceListItem) => Action<InvoiceListItem>))[]
    | undefined => {
    if (!downloadAction) return tableData.actions;

    const downloadActionItem = (rowData: InvoiceListItem): Action<InvoiceListItem> => ({
      icon: actionIcons.Document,
      tooltip: tFormKey('Documento'),
      onClick: () => downloadInvoice(rowData.file_id || 0, rowData.filename || ''),
    });

    tableData.actions = tableData.actions ? [downloadActionItem, ...tableData.actions] : [downloadActionItem];

    return tableData.actions;
  };

  const goToInvoiceEdit = (rowData: InvoiceListItem) => {
    const { id } = rowData;
    history.push({
      pathname: `/contabilidad/facturas/editar/${id}`,
      state: { id },
    });
  };

  const internalTableData = {
    ...tableData,
    actions: tableActions(),
  };

  const localization = checkedRows
    ? ({
        toolbar: {
          nRowsSelected: tKey(`${checkedRows} Fila/s seleccionada/s`),
        },
      } as Localization)
    : undefined;

  return (
    <div className={style.invoice_table}>
      <TableWithEdit
        onRowClick={goToInvoiceEdit}
        onSelectionChange={onSelectionChange}
        tableData={{ ...internalTableData }}
        filtering
        key={JSON.stringify(tableData.data)}
        permission={true}
        localization={localization}
      />
    </div>
  );
};

const mapDispatchToProps = (dispatch: any) => ({
  downloadInvoice: (file_id: number, filename: string) => dispatch(downloadInvoiceDocument(file_id, filename)),
});

export default connect(() => ({}), mapDispatchToProps)(InvoicesList);
